import React from "react";

import { Graph } from "~/Graph";

export type Type = {
  readonly type: Graph.Generated.Driver__VehicleInspectionReport__Type;
};

export function Type(type: Type) {
  return <>{Type.toString(type)}</>;
}

export namespace Type {
  export const general = (): Type => ({
    type: Graph.Generated.Driver__VehicleInspectionReport__Type.General,
  });

  export const incident = () => ({
    type: Graph.Generated.Driver__VehicleInspectionReport__Type.Incident,
  });

  export const preTrip = () => ({
    type: Graph.Generated.Driver__VehicleInspectionReport__Type.PreTrip,
  });

  export const postTrip = () => ({
    type: Graph.Generated.Driver__VehicleInspectionReport__Type.PostTrip,
  });

  export const toString = ({ type }: Type): string =>
    type === general().type
      ? "General"
      : type === incident().type
      ? "Incident"
      : type === preTrip().type
      ? "Pre-trip"
      : "Post-trip";
}

export namespace Types {
  export const list = () => [
    Type.general(),
    Type.incident(),
    Type.preTrip(),
    Type.postTrip(),
  ];
}
